import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import classNames from "classnames";
import { getRehydratableName, getClassNameFactory } from "../../utilities";
import SearchInput from "../../elements/SearchInput";
import CrossIcon from "@dcl/icons/esm/ui/cross";
import HamburgerIcon from "@dcl/icons/esm/ui/hamburger";
import SearchIcon from "@dcl/icons/esm/ui/search";
import Column from "./components/Column";
import FeaturedItem from "./components/FeaturedItem";
import Flyouts from "./components/Flyouts";
import Menu from "./components/Menu";
import NavList from "./components/NavList";
import NavItem from "./components/NavItem";
import Section from "./components/Section";
import SectionStack from "./components/SectionStack";
import Logo from "./components/Logo";
import injectPropsToChildren from "./injectPropsToChildren";
import { SearchBox } from "@dcl-ue/coveo-search";

var SiteHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(SiteHeader, _React$Component);

  var _super = _createSuper(SiteHeader);

  function SiteHeader() {
    var _this;

    _classCallCheck(this, SiteHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "searchButtonRef", null);

    _defineProperty(_assertThisInitialized(_this), "state", {
      currentMenu: null,
      expanded: false,
      searching: false,
      isCoveoSearchExpanded: false
    });

    _defineProperty(_assertThisInitialized(_this), "coveoSearchProps", _objectSpread({}, _this.props.coveoSearchBox));

    _defineProperty(_assertThisInitialized(_this), "searchRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "menusRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "buttonsRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleSearchBlur", function (e) {
      // document.activeElement is IE11 fallback
      var relatedTarget = e.relatedTarget || document.activeElement; // This prevents blur from triggering an additional setState in the event
      // that the search button is tapped on mobile.

      if (relatedTarget && (_this.searchRef && _this.searchRef.contains(relatedTarget) || _this.buttonsRef && _this.buttonsRef.contains(relatedTarget))) {
        return;
      }

      _this.setState({
        searching: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSearchClick", function () {
      _this.setState({
        searching: !_this.state.searching
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggleClick", function () {
      var expanded = !_this.state.expanded;
      window.scrollTo(0, 0);

      if (expanded) {
        document.body.classList.add("u-bodyModalOpenNarrowOnly");
      } else {
        document.body.classList.remove("u-bodyModalOpenNarrowOnly");
      }

      _this.setState({
        expanded: expanded
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setOpenMenu", function (menuId) {
      if (_this.menusRef) {
        // Scroll back to 0, so that panels are in view and
        // cover the available space and can't be over-scrolled.
        _this.menusRef.scrollTop = 0;
      }

      _this.setState({
        currentMenu: menuId
      });
    });

    _defineProperty(_assertThisInitialized(_this), "registerRef", function (refName) {
      return function (ref) {
        if (ref) {
          _this[refName] = ref;
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "passPropsToMenuChildren", function (children) {
      return injectPropsToChildren(children, function (_ref) {
        var props = _ref.props,
            type = _ref.type;

        if (type === Menu) {
          return _objectSpread(_objectSpread({}, props), {}, {
            setOpenMenu: _this.setOpenMenu,
            currentMenu: _this.state.currentMenu,
            expanded: props.title === _this.state.currentMenu
          });
        }

        return props;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getElementRole", function (role) {
      return role && role !== "none" ? {
        role: role
      } : null;
    });

    _defineProperty(_assertThisInitialized(_this), "activeElementFocus", function () {
      if (document.activeElement) {
        document.activeElement.scrollIntoView({
          block: "nearest"
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeypress", function (evt) {
      if (_this.state.expanded) {
        var activeElement = document.activeElement;
        var getClassName = getClassNameFactory("SiteHeader");

        switch (evt.key) {
          case "Escape":
            _this.setState({
              expanded: false
            });

            break;

          case "Tab":
            // Shift + Tab on logo -> go to toggle button
            if (evt.shiftKey && activeElement !== null && activeElement !== void 0 && activeElement.classList.value.includes("SiteHeader-logo")) {
              var toggleButton = document.querySelector(".".concat(getClassName({
                descendantName: "toggleButton"
              })));
              evt.preventDefault();
              toggleButton.focus();
            } // Tab on toggle button -> go to logo
            else if (!evt.shiftKey && activeElement !== null && activeElement !== void 0 && activeElement.classList.value.includes("SiteHeader-toggleButton")) {
                var logo = document.querySelector(".".concat(getClassName({
                  descendantName: "logo"
                })));
                evt.preventDefault();
                logo.focus();
              }

            break;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onHeaderStateChange", function (isExpanded) {
      _this.setState({
        isCoveoSearchExpanded: isExpanded
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCoveoSeparator", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "coveo-tr-search-header-expanded"
      });
    });

    return _this;
  }

  _createClass(SiteHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.menusRef) {
        this.menusRef.addEventListener("focus", this.activeElementFocus, true);
        window.addEventListener("keydown", this.handleKeypress);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.searching && !this.state.searching && this.searchButtonRef) {
        this.searchButtonRef.focus();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.menusRef) {
        this.menusRef.removeEventListener("focus", this.activeElementFocus);
        window.removeEventListener("keydown", this.handleKeypress);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var getClassName = getClassNameFactory("SiteHeader");
      var _this$props = this.props,
          search = _this$props.search,
          siteName = _this$props.siteName,
          searchFormAction = _this$props.searchFormAction,
          searchFormMethod = _this$props.searchFormMethod,
          searchInputName = _this$props.searchInputName,
          typeaheadUrl = _this$props.typeaheadUrl,
          logoHref = _this$props.logoHref,
          logoText = _this$props.logoText,
          isPrideMonth = _this$props.isPrideMonth,
          children = _this$props.children,
          NavigationAriaTag = _this$props.NavigationAriaTag,
          role = _this$props.role,
          menuRole = _this$props.menuRole,
          placeholder = _this$props.placeholder,
          isCoveoSearchEnabled = _this$props.isCoveoSearchEnabled,
          isCoveoSearchHeadlessEnabled = _this$props.isCoveoSearchHeadlessEnabled;
      return /*#__PURE__*/React.createElement("div", _extends({}, this.getElementRole(role), {
        className: getClassName({
          states: classNames({
            expanded: this.state.expanded,
            expandedMenu: this.state.currentMenu !== null,
            searching: this.state.searching
          }),
          modifiers: classNames({
            noSearch: !search,
            withSiteName: Boolean(siteName)
          })
        }),
        "data-search": search,
        "data-search-form-action": searchFormAction,
        "data-search-form-method": searchFormMethod,
        "data-search-input-name": searchInputName,
        "data-rehydratable": getRehydratableName(SiteHeader.displayName),
        "data-typeahead-url": typeaheadUrl,
        "data-placeholder": placeholder,
        "data-is-coveo-search-enabled": isCoveoSearchEnabled,
        "data-is-coveo-search-headless-enabled": isCoveoSearchHeadlessEnabled
      }), /*#__PURE__*/React.createElement(NavigationAriaTag, {
        className: getClassName({
          descendantName: "inner"
        }),
        "aria-label": "header"
      }, /*#__PURE__*/React.createElement(Logo, {
        logoHref: logoHref,
        logoText: logoText,
        isPrideMonth: isPrideMonth
      }), this.props.isCoveoSearchEnabled && this.state.isCoveoSearchExpanded && this.handleCoveoSeparator(), siteName && /*#__PURE__*/React.createElement("a", {
        className: getClassName({
          descendantName: "siteName",
          utilities: "typographySmallCaps"
        }),
        href: logoHref,
        id: this.props.isCoveoSearchEnabled && this.state.isCoveoSearchExpanded ? "coveo-tr-search-header-component" : ""
      }, siteName), !this.state.searching && !this.state.isCoveoSearchExpanded && /*#__PURE__*/React.createElement("ul", _extends({
        className: getClassName({
          descendantName: "menus"
        }),
        ref: this.registerRef("menusRef")
      }, this.getElementRole(menuRole)), this.passPropsToMenuChildren(children)), /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "buttons"
        }),
        ref: this.registerRef("buttonsRef")
      }, !this.state.isCoveoSearchExpanded && /*#__PURE__*/React.createElement("button", {
        "aria-label": "Main menu",
        "aria-expanded": this.state.expanded ? "true" : "false",
        className: getClassName({
          descendantName: "toggleButton"
        }),
        onClick: this.handleToggleClick
      }, this.state.expanded ? /*#__PURE__*/React.createElement(CrossIcon, null) : /*#__PURE__*/React.createElement(HamburgerIcon, null)), search && !this.props.isCoveoSearchEnabled && /*#__PURE__*/React.createElement("button", {
        ref: this.registerRef("searchButtonRef"),
        "aria-label": "Search",
        className: getClassName({
          descendantName: "searchButton"
        }),
        onClick: this.handleSearchClick,
        onKeyDown: function onKeyDown(e) {
          if (e.key === "Escape") {
            _this2.setState({
              searching: false
            });

            e.stopPropagation();
            e.preventDefault();
          }
        }
      }, this.state.searching ? /*#__PURE__*/React.createElement(CrossIcon, null) : /*#__PURE__*/React.createElement(SearchIcon, null)), this.props.isCoveoSearchEnabled && !this.state.expanded && !this.props.isCoveoSearchHeadlessEnabled && /*#__PURE__*/React.createElement(SearchBox, _extends({}, this.coveoSearchProps, {
        onHeaderStateChange: this.onHeaderStateChange
      }))), this.state.searching && /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "search"
        }),
        ref: this.registerRef("searchRef")
      }, /*#__PURE__*/React.createElement("form", {
        action: searchFormAction,
        method: "GET",
        role: "search"
      }, /*#__PURE__*/React.createElement(SearchInput // When the user clicks the search button, and the search
      // input appears, the expectation is that the input will be in
      // focus.
      , {
        autoFocus: true // eslint-disable-line jsx-a11y/no-autofocus
        ,
        name: searchInputName,
        typeahead: Boolean(typeaheadUrl),
        typeaheadUrl: typeaheadUrl,
        onBlur: this.handleSearchBlur,
        placeholder: placeholder
      })))));
    }
  }]);

  return SiteHeader;
}(React.Component);

_defineProperty(SiteHeader, "displayName", "SiteHeader");

_defineProperty(SiteHeader, "defaultProps", {
  logoText: "Thomson Reuters",
  search: true,
  searchFormAction: null,
  searchFormMethod: "get",
  searchInputName: "q",
  typeaheadUrl: null,
  NavigationAriaTag: "nav",
  role: "banner",
  menuRole: "menubar",
  placeholder: "Search",
  isCoveoSearchEnabled: false,
  isCoveoSearchHeadlessEnabled: false
});

_defineProperty(SiteHeader, "Column", Column);

_defineProperty(SiteHeader, "FeaturedItem", FeaturedItem);

_defineProperty(SiteHeader, "Flyouts", Flyouts);

_defineProperty(SiteHeader, "Menu", Menu);

_defineProperty(SiteHeader, "NavList", NavList);

_defineProperty(SiteHeader, "NavItem", NavItem);

_defineProperty(SiteHeader, "Section", Section);

_defineProperty(SiteHeader, "SectionStack", SectionStack);

export default SiteHeader;